<template>
  <page-edicion>
    <page-header title="Crear factor de complejidad" back-to="/complejidadesProyecto" />
    <formulario :complejidad-proyecto="complejidadProyecto" @submit="insertar" />
  </page-edicion>
</template>

<script>
import { mapActions } from "pinia";
import Formulario from "./Formulario.vue";
import api from "@/services/complejidadesProyecto.js";

export default {
  components: { Formulario },
  data() {
    return {
      complejidadProyecto: {},
    };
  },
  methods: {
    insertar() {
      api.insertar(this.complejidadProyecto).then(() => {
        this.$messages.success("Se ha creado el registro");
        this.$router.push({ path: "/complejidadesProyecto" });
      });
    },
  },
};
</script>
